const Country = {

    // FIELDS
    "name": "Pangalan",
    "status": "Katayuan",
    "search": "Maghanap",

    // PAGE HEADER
    "country": "Bansa",

    // ERROR
    "error_name": "Ilagay ang Pangalan",
    "error_status": "Piliin ang Katayuan",

    // TABLE HEADER
    "table_name": "PANGALAN",
    "table_status": "KATAYUAN",

}

export default Country;